module.exports = __webpack_public_path__ + "media/img/google-play@2x-9cba6005.png";